module.exports = __webpack_public_path__ + "static/media/2-1.b876f6e3.png";